import css from "standard/css";
import status from "./status";

const style = css`
  .study {
    align-items: center;
    background-color: var(--color-master-light);
    border-radius: var(--border-radius-sm);
    color: var(--color-master);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-medium);
    gap: var(--spacing_inset-nano);
    height: 42px;
    justify-content: center;
    text-decoration: none;
    width: 160px;
  }

  .study[${status.TO_REVIEW}] {
    background-color: var(--color-primary);
    color: var(--color-master-lightest);
  }
`;

export default style;
